<template>
    <div>
        <v-container>
            <v-row dense>
                <v-col cols="4" />

                <v-col cols="2" class="offerTitleBackground">
                    <v-sheet class="d-flex justify-center align-center basicOfferTitle"
                        >FREEMIUM</v-sheet
                    >
                </v-col>

                <v-col cols="2" class="offerTitleBackground">
                    <v-sheet class="d-flex justify-center align-center essentialOfferTitle">
                        SMART
                    </v-sheet>
                </v-col>

                <v-col cols="2" class="offerTitleBackground">
                    <v-sheet class="d-flex justify-center align-center essentialOfferTitle"
                        >ESSENTIEL</v-sheet
                    >
                </v-col>

                <v-col cols="2" class="offerTitleBackground">
                    <v-sheet class="d-flex justify-center align-center premiumOfferTitle"
                        >PREMIUM</v-sheet
                    >
                </v-col>
            </v-row>
            <v-row
                dense
                :style="{ 'overflow-y': 'auto', 'max-height': maxHeight, 'overflow-x': 'hidden' }"
            >
                <v-col cols="12">
                    <template
                        v-for="(category, categories_index) in scheme"
                        :key="categories_index"
                    >
                        <v-row dense>
                            <v-col cols="4">
                                <v-sheet class="titleCategory">{{ category.title }}</v-sheet>
                            </v-col>

                            <v-col
                                cols="2"
                                v-if="category.basicOffer && category.basicOffer.colorised"
                                class="pb-0 pt-0"
                            >
                                <div class="basicOfferBackground ml-2 mr-4 pb-0 pt-0"></div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else />

                            <v-col
                                cols="2"
                                v-if="category.smartOffer && category.smartOffer.colorised"
                                class="pb-0 pt-0"
                            >
                                <div class="essentialOfferBackground ml-2 mr-4 pb-0 pt-0"></div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else />

                            <v-col
                                cols="2"
                                v-if="category.essentialOffer && category.essentialOffer.colorised"
                                class="pb-0 pt-0"
                            >
                                <div class="premiumOfferBackground ml-2 mr-4 pb-0 pt-0"></div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else />

                            <v-col
                                cols="2"
                                v-if="category.premiumOffer && category.premiumOffer.colorised"
                                class="pb-0 pt-0"
                            >
                                <div class="essentialOfferBackground ml-2 mr-4 pb-0 pt-0"></div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else />
                        </v-row>
                        <v-row
                            v-for="(subCategory, index) in category.categories"
                            :key="categories_index * 10000 + (index + 1)"
                            dense
                        >

                            <v-col cols="4">
                                <v-sheet class="titleSubCategory">{{ subCategory.title }}</v-sheet>
                            </v-col>

                            <v-col
                                cols="2"
                                v-if="
                                    subCategory.basicOffer &&
                                    subCategory.basicOffer.colorised &&
                                    subCategory.basicOffer.isEnd
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="basicOfferEndBackground ml-2 mr-4">
                                    <v-icon
                                        v-if="
                                            subCategory.basicOffer && subCategory.basicOffer.valid
                                        "
                                        class="d-flex justify-center basicOfferIcon"
                                        >{{ subCategory.basicOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col
                                cols="2"
                                v-else-if="
                                    subCategory.basicOffer && subCategory.basicOffer.colorised
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="basicOfferBackground ml-2 mr-6">
                                    <v-icon
                                        v-if="
                                            subCategory.basicOffer && subCategory.basicOffer.valid
                                        "
                                        class="d-flex justify-center basicOfferIcon"
                                        >{{ subCategory.basicOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else> </v-col>

                            <v-col
                                cols="2"
                                v-if="
                                    subCategory.smartOffer &&
                                    subCategory.smartOffer.colorised &&
                                    subCategory.smartOffer.isEnd
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="essentialOfferEndBackground ml-2 mr-4">
                                    <v-icon
                                        v-if="
                                            subCategory.smartOffer &&
                                            subCategory.smartOffer.valid
                                        "
                                        class="d-flex justify-center essentialOfferIcon"
                                        >{{ subCategory.smartOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col
                                cols="2"
                                v-else-if="
                                    subCategory.smartOffer &&
                                    subCategory.smartOffer.colorised
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="essentialOfferBackground ml-2 mr-4">
                                    <v-icon
                                        v-if="
                                            subCategory.smartOffer &&
                                            subCategory.smartOffer.valid
                                        "
                                        class="d-flex justify-center essentialOfferIcon"
                                        >{{ subCategory.smartOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else> </v-col>

                            <v-col
                                cols="2"
                                v-if="
                                    subCategory.essentialOffer &&
                                    subCategory.essentialOffer.colorised &&
                                    subCategory.essentialOffer.isEnd
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="premiumOfferEndBackground ml-2 mr-4">
                                    <v-icon
                                        v-if="
                                            subCategory.essentialOffer &&
                                            subCategory.essentialOffer.valid
                                        "
                                        class="d-flex justify-center premiumOfferIcon"
                                        >{{ subCategory.essentialOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col
                                cols="2"
                                v-else-if="
                                    subCategory.essentialOffer &&
                                    subCategory.essentialOffer.colorised
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="premiumOfferBackground ml-2 mr-4">
                                    <v-icon
                                        v-if="
                                            subCategory.essentialOffer &&
                                            subCategory.essentialOffer.valid
                                        "
                                        class="d-flex justify-center premiumOfferIcon"
                                        >{{ subCategory.essentialOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else> </v-col>

                            <v-col
                                cols="2"
                                v-if="
                                    subCategory.premiumOffer &&
                                    subCategory.premiumOffer.colorised &&
                                    subCategory.premiumOffer.isEnd
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="essentialOfferEndBackground ml-2 mr-4">
                                    <v-icon
                                        v-if="
                                            subCategory.premiumOffer &&
                                            subCategory.premiumOffer.valid
                                        "
                                        class="d-flex justify-center essentialOfferIcon"
                                        >{{ subCategory.premiumOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col
                                cols="2"
                                v-else-if="
                                    subCategory.premiumOffer && subCategory.premiumOffer.colorised
                                "
                                class="pb-0 pt-0"
                            >
                                <div class="essentialOfferBackground ml-2 mr-8">
                                    <v-icon
                                        v-if="
                                            subCategory.premiumOffer &&
                                            subCategory.premiumOffer.valid
                                        "
                                        class="d-flex justify-center essentialOfferIcon"
                                        >{{ subCategory.premiumOffer.icon }}</v-icon
                                    >
                                </div>
                            </v-col>
                            <v-col cols="2" class="pb-0 pt-0" v-else> </v-col>
                        </v-row>
                    </template>
                </v-col>
            </v-row>
        </v-container>
        <div v-if="isDisplayPrice">
            <v-row dense>
                <v-col cols="4">
                    <v-tooltip>
                        <template v-slot:activator="{ props }">
                            <div>Tarif €/mois <v-icon v-bind="props">$oss-help</v-icon></div>
                        </template>
                        1 société, 3 utilisateurs avec tous les droits, un nombre illimité
                        d'utilisateurs à droit restreints au dépôt de pièces et gestion des notes de
                        frais
                    </v-tooltip>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>{{ !isWithoutLogingView ? basicPrice : "0 €" }}</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>{{ !isWithoutLogingView ? smartPrice : "49 €" }}</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>{{ !isWithoutLogingView ? essentialPrice : "69 €" }}</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>{{ !isWithoutLogingView ? premiumPrice : "99 €" }}</strong>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="4" size="x-small"> Tarif €/mois pour une SCI </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>/</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>19 €</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>19 €</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong>19 €</strong>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="4" size="x-small">
                    <span size="x-small">Tarif €/mois/Utilisateur Supplémentaire</span>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">/</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">9 €</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">9 €</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">9 €</strong>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="4" size="x-small">
                    <span size="x-small">Durée d'engagement minimale</span>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">1 mois</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">12 mois</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">12 mois</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">12 mois</strong>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="4" size="x-small">
                    <span size="x-small">Parcours eLearning (obligatoire)</span>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">-</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">150€/ utilisateur</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">150€/ utilisateur</strong>
                </v-col>
                <v-col cols="2" class="d-flex justify-center align-center" size="x-small">
                    <strong size="x-small">150€/ utilisateur</strong>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script lang="ts">
import { Offer_type } from "@/types/offer.types";
import businessOfferScheme from "@/assets/json/businessOfferScheme.json";

import GET_BOBBEE_PRICES from "@/graphql/bobbeePriceList/GetBobbeePrices.gql";

import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Model } from "vue-facing-decorator";

type Price_Type = {
    price: number;
    offer: Offer_type;
    discount: number;
};

@Component
export class BusinessOffer extends Vue {
    @Model({ required: false, default: Offer_type.BUSINESS_BASIC, name: "offer" })
    _offer: Offer_type;
    @Prop({ default: "30vh" }) maxHeight: string;
    @Prop({ default: false }) isDisplayPrice: boolean;
    @Prop({ default: false }) isWithoutLogingView: boolean;

    scheme: any = businessOfferScheme;
    prices: Price_Type[] = [];

    getOfferType(offer) {
        switch (offer) {
            case "ACCOUNTING_STARTER":
                return Offer_type.ACCOUNTING_STARTER;
            case "ACCOUNTING_BASIC":
                return Offer_type.ACCOUNTING_BASIC;
            case "ACCOUNTING_ESSENTIAL":
                return Offer_type.ACCOUNTING_ESSENTIAL;
            case "ACCOUNTING_PREMIUM":
                return Offer_type.ACCOUNTING_PREMIUM;
            case "BUSINESS_BASIC":
                return Offer_type.BUSINESS_BASIC;
            case "BUSINESS_ESSENTIAL":
                return Offer_type.BUSINESS_ESSENTIAL;
            case "BUSINESS_PREMIUM":
                return Offer_type.BUSINESS_PREMIUM;
            case "BUSINESS_SMART":
                return Offer_type.BUSINESS_SMART;
        }
    }

    async beforeMount() {
        if (!this.isWithoutLogingView && this.isDisplayPrice) {
            const result = await this.$apollo.query({
                query: GET_BOBBEE_PRICES,
                variables: {
                    companyId: this.$store.state.selected_company.id,
                },
            });
            const bobbeePrice = result.data.getBobbeePrices.prices;
            for (const price of bobbeePrice.prices) {
                const discount =
                    (bobbeePrice.discount ? bobbeePrice.discount : 0) +
                    (price.discount ? price.discount : 0);
                const unitPrice = price.unitPrice * ((100 - discount) / 100);
                const offer = this.getOfferType(price.offer);
                const tmpPrice: Price_Type = { price: unitPrice, offer: offer, discount: discount };
                this.prices.push(tmpPrice);
            }
        }
    }

    get basicPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.BUSINESS_BASIC) return price.price;
        }
        return "0";
    }

    get smartPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.BUSINESS_SMART) return price.price;
        }
        return "0";
    }

    get essentialPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.BUSINESS_ESSENTIAL) return price.price;
        }
        return "0";
    }

    get premiumPrice() {
        for (const price of this.prices) {
            if (price.offer == Offer_type.BUSINESS_PREMIUM) return price.price;
        }
        return "0";
    }
}

export default toNative(BusinessOffer);
</script>

<style lang="css" scoped src="../../assets/style/businessOfferStyle.css"></style>
